import { render, staticRenderFns } from "./FormLogo.vue?vue&type=template&id=4efea2d4&"
import script from "./FormLogo.vue?vue&type=script&lang=js&"
export * from "./FormLogo.vue?vue&type=script&lang=js&"
import style0 from "./FormLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports